import defaultState from 'redux/defaultState';

export default (meta = defaultState.meta, action) => {
  if (action.type === 'META_TITLE') {
    return {
      ...meta,
      title: action.payload
    };
  }

  return meta;
};
